'use strict';
(function () {
  var _controller = 'newClub.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', '$q', '$injector', 'clubBenefit.resource', 'clubRules.resource', 'image.resource'];
  function controller($scope, $q, $injector, clubBenefitResource, clubRulesResource, imageResource) {
    var clubLogResource = $scope.$root.employeeApp ? null : $injector.get('clubLog.resource');
    var pointsResource = $scope.$root.employeeApp ? $injector.get('point.resource') : $injector.get('points.resource');
    var clubLogHistoryModal = $scope.$root.employeeApp ? null : $injector.get('clubLogHistory.modal');
    var scoringRulesModal = $scope.$root.employeeApp ? null : $injector.get('scoringRules.modal');
    var clubAddPoints = $scope.$root.employeeApp ? null : $injector.get('clubAddPoints.resource');
    var genericModal = $scope.$root.employeeApp ? $injector.get('generic.modal') : null
    var clubCardResource = $scope.$root.employeeApp ? $injector.get('clubCard.resource') : null

    /// METHODS
    $scope.imageResource = imageResource;
    $scope.redeem = redeem;
    $scope.payWithPoints = payWithPoints;
    $scope.showHistory = showHistory;
    $scope.showRules = showRules;
    $scope.showVouchers = showVouchers;
    $scope.isExpanded = isExpanded;
    $scope.expandCard = expandCard;

    /// VARS
    $scope.active = 'ADD';
    $scope.points = []; //- tipo de puntos
    $scope.rulesDataAdd = []; //- reglas para sumar. tab ADD
    $scope.rulesDataOut = []; //- reglas para canjear. tab EXCHANGE
    $scope.historyData = []; //- historial. tab HISTORY
    $scope.almostOneRouterWithPOSIntegration =
      $scope.$root.routers &&
      $scope.$root.routers.find(function (f) {
        return f.hasPosIntegration;
      });

    // WATCHERS
    $scope.$on('$destroy', onDestroy);
    $scope.$on('defaultRouter', refresh);
    if (!$scope.$root.employeeApp && !profile._id) {
      $injector.get('bottomLogin.modal').open({ title: i18next.t('Debes iniciar sesión') });
      $scope.$on('login', refresh);
    } else refresh();
    /// INIT

    /////////////////////
    function refresh() {
      let rules, benefits, point;
      getRules()
        .then(function (result) {
          rules = result;
          rules.forEach(function (rule) {
            rule._conditions = window.clubFunctions.getTermsAndConditions(rule.match, $scope.$root.routers);
          });
          return getPoints(rules);
        }).then(function (result) {
          if (!result) throw new PentaError('No hay punto configurado');
          point = result;
          return getBenefits(point);
        })
        .then(function (result) {
          benefits = result;
          if ($scope.$root.employeeApp) return getClubCards(benefits)
          else return
        })
        .then(function () {
          processPoint(point, rules, benefits);
          getTotalOfPoint(point, benefits);
          applyPointStyle(point);
          setTimeout(function () {
            if ($scope.$root.employeeApp) return;
            var newClubPage = $('.new-club')[0];
            if (!newClubPage) return;
            var height = calcBenefitsHeight(newClubPage);
            if (!height) return;
            var pointBenefits = newClubPage.querySelector('.point-benefits');
            if (pointBenefits) pointBenefits.style.maxHeight = height + 'px';
          }, 0);
          $scope.point = point;
        })
        .catch(function (err) {
          if (err) throw new PentaError(err);
        });
      return;
    }

    //- Obtengo las reglas
    function getRules() {
      return $q(function (resolve, reject) {
        clubRulesResource
          .query({ userType: $scope.$root.employeeApp ? 'EMPLOYEE' : 'CLIENT', _select: ['*'], _controller: _controller, _ignoreVeil: true })
          .$promise.then(function (result) {
            resolve(result);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    //- Obtengo los beneficios
    function getBenefits(point) {
      return $q(function (resolve, reject) {
        let filter = { _select: ['*'], _controller: _controller, _ignoreVeil: true }
        if ($scope.$root.employeeApp) {
          filter._defaultQuery = true;
          filter['content.point'] = point._id;
          filter.userCredential = window.profile.userId
        }
        clubBenefitResource
          .query(filter)
          .$promise.then(function (result) {
            resolve(result);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    //- Obtengo los tipos de punto puntos y asigno el primero del array que tenga regla de salida.
    function getPoints(rules) {
      return $q(function (resolve, reject) {
        pointsResource
          .query({
            list: $scope.$root.employeeApp ? undefined : true,
            enterarse: $scope.$root.employeeApp ? undefined : window.enterprise,
            _controller: _controller,
            _ignoreVeil: true,
            _select: ['*'],
          })
          .$promise.then(function (result) {
            if (!result || !result.length) return resolve();
            var point;
            if (
              !!rules.find(function (f) {
                return f.point === result[0]._id && f.direction === 'OUT';
              })
            )
              point = result[0];
            resolve(point);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    //- Se procesa el tipo de puntos para obtener datos necesarios.
    function processPoint(point, rules, benefits) {
      if (!point) return;
      //- Asigno Reglas
      point._rulesDataAdd = rules.filter(function (f) {
        return f.point === point._id && f.direction === 'IN';
      });
      point._rulesDataOut = rules.filter(function (f) {
        if (f.point !== point._id) return false;
        if (f.direction !== 'OUT') return false;
        //-Filtro aquellas reglas que no pertenezcan a el defaultRouter
        if (
          !f.match &&
          !f.match.routers &&
          !f.match.routers.length &&
          !f.match.routers.find(function (router) {
            return router === $scope.$root.defaultRouter;
          })
        )
          return false;
        return f;
      });
      //- Asigno Historial de beneficios
      point._historyBenefits = benefits.filter(function (f) {
        return f.content.type === 'POINT' && f.content.point === point._id;
      });
      //- Calculo puntos que expiran
      let expireBenefits = point._historyBenefits.filter(function (f) {
        if (f.expireAt) f.expireAt = new Date(f.expireAt);
        return !!f.expireAt;
      });
      let nextExpireBenefit = expireBenefits.sort(function (a, b) {
        return a.expireAt - b.expireAt;
      })[0];
      if (!nextExpireBenefit) return;
      let totalPointsExpire = expireBenefits.reduce(function (total, benefit) {
        if (!benefit.expireAt || moment(benefit.expireAt).format('DDMMyyyy') !== moment(nextExpireBenefit.expireAt).format('DDMMyyyy')) return total;
        return total + (benefit.content.amount || 0);
      }, 0);
      point._nextExpire = {
        points: totalPointsExpire,
        date: nextExpireBenefit.expireAt,
      };
    }

    function getClubCards() {
      return $q(function (resolve, reject) {
        if (!window.profile.userId) throw new PentaErrro(i18next.t('Faltan datos para obtener Vouchers'))
        let clubCards = [];
        clubCardResource.query({ _select: ['*'], userCredential: window.profile.userId }).$promise
          .then(function (data) {
            if (!data.length) return
            clubCards = data;
            return clubBenefitResource.query({ _select: ['*'], _defaultQuery: true, clubCard_in: data.map(f => f._id) }).$promise
          })
          .then(function (clubBenefits) {
            let now = moment().utcOffset(0);
            for (let clubCard of clubCards) {
              clubCard.benefits = clubBenefits.filter(f => f.clubCard === clubCard._id);
              if (clubCard.benefits && clubCard.benefits.length) {
                clubCard.benefits = benefitFilter(clubCard.benefits, now)
                if (clubCard.benefits.find(function (b) { return b.content && (b.content.type === "MANUAL-IMPLEMENTATION") }))
                  clubCard._manualImplementation = true;
              }
            }
            $scope.clubCards = clubCards.filter(function (card) { return card.benefits && card.benefits.length });
            resolve()
          })
          .catch(function (err) { reject(err); });
      })
    }

    function benefitFilter(benefits, now) {
      if (!benefits || !benefits.length) return [];
      return benefits.filter(function (benefit) {
        if (!benefit) return
        if (benefit.match && benefit.match.dateEnd) {
          var end = moment(benefit.match.dateEnd).utcOffset(0);
          if (end < now) return
        }
        return benefit;
      })
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    function applyPointStyle(point) {
      //- text color
      var style = {};
      if (point.pwaDesign && point.pwaDesign.textColor) style['color'] = point.pwaDesign.textColor;
      else style['color'] = 'white';
      //- background
      if (!point.inAppBackgroundMode || (point.inAppBackgroundMode && !point.pwaDesign) || !point.pwaDesign.background) {
        style['background'] = 'url(/frontend/static/img/fondowallet.jpg)';
        style['background-repeat'] = 'repeat';
      } else if (point.inAppBackgroundMode === 'REPEAT') {
        style['background'] = 'url(/api/image?_file=image&_id=' + point.pwaDesign.background + ')';
        style['background-repeat'] = 'repeat';
      } else if (point.inAppBackgroundMode === 'CONTAIN') {
        style['background'] = 'url(/api/image?_file=image&_id=' + point.pwaDesign.background + ')';
        style['background-size'] = 'contain';
        style['background-position'] = 'center';
        style['background-repeat'] = 'no-repeat';
        style['background-color'] = 'dimgrey';
      } else if (point.inAppBackgroundMode === 'COVER') {
        style['background'] = 'url(/api/image?_file=image&_id=' + point.pwaDesign.background + ')';
        style['background-size'] = 'cover';
      }
      point._style = style;
    }

    //- Obtener puntos totale
    function getTotalOfPoint(point, benefits) {
      if (!point || !benefits || !benefits.length) return console.error(i18next.t('ERR AL OBTENER TOTAL DE PUNTOS'));
      point._totalPoints = benefits.reduce(function (total, benefit) {
        if (!benefit.content || benefit.content.point !== point._id) return total;
        return total + (benefit.content.amount || 0);
      }, 0);
    }

    function redeem(clubRule) {
      var values = {
        date: moment(),
        utcOffset: $scope.$root.routers.find((f) => {
          return f._id === $scope.$root.defaultRouter;
        }).utcOffset,
        defaultRouter: $scope.$root.defaultRouter,
      };
      if (!window.clubFunctions.doesMatch(clubRule.match, values))
        return ons.notification.alert({
          title: i18next.t('Beneficio no vigente'),
          message: clubRule._conditions && clubRule._conditions.length > 1 ? clubRule._conditions : '',
        });
      ons.notification.confirm({ message: i18next.t('¿Seguro que deseas canjear?'), title: 'Confirmación' }).then(function (result) {
        if (!result) return;
        let message = $scope.$root.employeeApp ? i18next.t('Ya adquiriste tu beneficio. Haz click en el botón "Vouchers" para canjearlo') : i18next.t('Beneficios canjeados con éxito! Verifica la seccion Vouchers')
        clubRulesResource.save({ clubRule: clubRule._id, point: clubRule.point }, function () {
          refresh();
          ons.notification.alert({
            title: i18next.t('¡Listo!'),
            message: message,
          });
        });
      });
    }

    /// Pagar con puntos no depende de la rule porque pueden matchear varias rules
    /// Esto es un poco raro, porque acá se está eligiendo una rule, el día de mañana
    /// debería aparecer una sola tarjeta para pagar con puntos
    function payWithPoints() {
      var payWithPointsModal = $injector.get('payWithPoints.modal');
      payWithPointsModal.open({
        onFinish: function () {
          refresh();
        },
      });
    }

    function showHistory() {
      if (!clubLogHistoryModal) throw new PentaError('FUNCIONALIDAD NO DISPONIBLE PARA EMPLEADOS');
      getLog()
        .then(function (result) {
          clubLogHistoryModal.open({ clubLogs: result }).then(Function.prototype).catch(Function.prototype);
        })
        .catch(function (err) {
          if (err) throw new PentaError(err);
        });
    }

    function showRules(rules, $event) {
      if (!rules) return;
      var rules = processRules(rules);
      if ($scope.$root.employeeApp) {
        genericModal.open({
          data: {},
          title: i18next.t('Reglas para sumar puntos'),
          groups: [{ label: '', fields: [{ type: 'NTN-LIST-VERTICAL', class: 'col-xs-12', list: rules }], },],
        })
          .then(Function.prototype)
          .catch(Function.prototype);
      } else scoringRulesModal.open({ rules: rules }).then(Function.prototype).catch(Function.prototype);
    }

    function showVouchers($event) {
      if (!$scope.$root.employeeApp) return
      let groups = [];
      if ($scope.clubCards.length) groups.push({ label: '', fields: [{ type: 'NTN-CLUB-CARD-VIEW', class: 'col-xs-12', clubCards: $scope.clubCards }] })
      else groups.push({ label: '', fields: [{ type: 'MESSAGE-INFO', class: 'col-xs-12', message: i18next.t('No tienes Vouchers disponibles por el momento') }] })
      genericModal.open({
        data: {},
        title: i18next.t('Vouchers'),
        hideIcon: true,
        buttonLabel: i18next.t('Salir'),
        groups: groups
      })
        .then(Function.prototype)
        .catch(Function.prototype);
    }

    function processRules(rules) {
      return rules.map(function (rule) {
        var amount;
        if (rule.amountType === 'FIXED') amount = '+' + rule.amount;
        else amount = rule.amount * 100 + '%';
        var result = { label: rule.name, value: amount, valueStyle: { color: '#00A756' } };
        if (rule.origin === 'TICKET-GUID')
          result.button = {
            label: i18next.t('Cargar Ticket'),
            disabled: window.profile._id ? false : true,
            function: () => addGuid(rule)
          }
        return result;
      });
    }

    function addGuid(rule) {
      if (!clubAddPoints) throw new PentaError('LOS_EMPLEADOS_NO_PUEDEN_SUMAR_POR_TICKET');
      ons.notification
        .prompt({
          inputType: 'number',
          title: i18next.t('Cargar ticket'),
          message: i18next.t('Ingrese el código que se encuentra al pie del ticket como GUID'),
        })
        .then(function (result) {
          if (!result) return;
          clubAddPoints.save(
            {
              rule: rule._id,
              origin: rule.origin,
              guid: result,
            },
            function (result) {
              if (!result.benefits || !result.benefits.length) throw new PentaError('No se pudo obtener el resumen de lo cargado, revise el historial');
              var pointsAdded = result.benefits
                .filter(function (f) {
                  return f.content.point === rule.point;
                })
                .reduce(function (acc, r) {
                  return (acc += r.content.amount || 0);
                }, 0);
              ons.notification.alert({ title: i18next.t('Puntos sumados'), message: i18next.t('Puntos sumados correctamente') + ': ' + Math.floor(pointsAdded) });
            }
          );
        });
    }

    function isExpanded(benefit) {
      if (!benefit || !benefit._id) return false;
      if (benefit._showSeeMoreButton) return true;
      var pointBenefit = $('.point-benefits');
      if (!pointBenefit || !pointBenefit.length) return false;
      var clubCardElement = pointBenefit[0].querySelector("[data-list='" + benefit._id + "']");
      if (!clubCardElement) return;
      benefit._showSeeMoreButton = showExpandButton(clubCardElement);
      if (benefit._showSeeMoreButton) setExpandSettings(benefit);
      return benefit._showSeeMoreButton;
    }

    function showExpandButton(clubCardElement) {
      var collapseElements = Array.from(clubCardElement.querySelectorAll('.collapse-text'));
      var show = false;
      for (var i = 0; i < collapseElements.length; i++) {
        var scrollWidth = Math.round($(collapseElements[i])[0].scrollWidth);
        var innerWidth = Math.round($(collapseElements[i]).innerWidth());
        if (scrollWidth > innerWidth) {
          show = true;
          break;
        }
      }
      return show;
    }

    function setExpandSettings(benefit) {
      if (!benefit || benefit._expandSettings) return;
      benefit._expandSettings = {
        text: i18next.t('VER MÁS'),
        expanded: false,
      };
    }

    function expandCard(benefit, $event) {
      if (!benefit || !benefit._showSeeMoreButton || !benefit._expandSettings || !$event || !$event.currentTarget) return;
      var elements = Array.from($event.currentTarget.querySelectorAll('.collapse-text'));
      elements.forEach(function (element) {
        if ($(element).hasClass('expand-text')) $(element).removeClass('expand-text');
        else $(element).addClass('expand-text');
      });
      elements.every(function (element) {
        if ($(element).hasClass('expand-text')) benefit._expandSettings = { text: i18next.t('VER MENOS'), expanded: true };
        else benefit._expandSettings = { text: i18next.t('VER MÁS'), expanded: false };
      });
    }

    function getLog() {
      return $q(function (resolve, reject) {
        if (!clubLogResource || !window.profile._id) return reject();
        clubLogResource
          .query({})
          .$promise.then(function (result) {
            resolve(result);
          })
          .catch(function (err) {
            reject(err);
          });
      });
    }

    function calcBenefitsHeight(pageElement) {
      if (!pageElement) return;
      var height;
      var marginTop = 16; //- Equivalente a 1rem en px.
      var visualAdjustment = 10; //- Ajuste de sombras.
      var onsToolbar = $('ons-toolbar')[0].offsetHeight;
      var onsBottomToolbar = $('ons-bottom-toolbar')[0].offsetHeight;
      var newClubPoint = pageElement.querySelector('.new-club-point');
      var changeTitle = pageElement.querySelector('.change-title');
      var pointActionsPanel = pageElement.querySelector('.point-actions-panel');
      height = pageElement.offsetHeight - ((onsToolbar || 0) + (onsBottomToolbar || 0));
      height -= (newClubPoint.offsetHeight || 0) + marginTop;
      height -= (changeTitle.offsetHeight || 0) + marginTop;
      height -= (pointActionsPanel.offsetHeight || 0) + marginTop;
      height -= marginTop + visualAdjustment; // 16
      return height;
    }
    //// FIN CONTROLLER
  }
})();
